export enum ZenModalStep {
    WELCOME = "WELCOME",
    CARD_DETAILS = "CARD_DETAILS",
    SUCCESS = "SUCCESS",
}